import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { listPedidosEmpresa } from '../../lib/adminApi';
import { tt } from '../../lib/empresasTxt';

export default function AdminPedidosEmpresa() {
  const { i18n } = useTranslation();
  const lang = (i18n.resolvedLanguage || 'es').toLowerCase();
  const T = (k, v) => tt(lang, k, v);
  const [rows, setRows] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => { listPedidosEmpresa().then((r) => setRows(r.data || [])).catch((e) => setError(e.message)); }, []);
  return (
    <div className="admin-page">
      <div className="admin-page-header"><h1>{T('a_titulo')}</h1></div>
      {error && <p className="modal-error-general">{error}</p>}
      {rows && rows.length === 0 && <p>{T('a_vacio')}</p>}
      {rows && rows.length > 0 && (
        <div className="admin-tabla-wrap">
          <table className="admin-tabla">
            <thead><tr><th>{T('a_fecha')}</th><th>{T('a_empresa')}</th><th>{T('a_pedido')}</th><th>{T('a_pagado')}</th><th>{T('a_enviadas')}</th></tr></thead>
            <tbody>
              {rows.map((p) => (
                <tr key={p.id}>
                  <td>{new Date(p.created_at).toLocaleDateString(lang)}</td>
                  <td><strong>{p.empresa_nombre}</strong><br /><small>{p.cif} · {p.contacto_email}</small>{p.factura_numero && <><br /><small><b>{T('a_factura')}:</b> {p.factura_numero}</small></>}</td>
                  <td>{p.unidades} × {Number(p.importe_por_tarjeta)} € <small>({p.tipo_destinatarios})</small></td>
                  <td>{Number(p.total_a_pagar).toFixed(2)} €{Number(p.descuento_pct) > 0 ? ` (−${Number(p.descuento_pct)}%)` : ''}<br /><small>{T('est_' + p.estado)}</small></td>
                  <td>{p.enviadas} / {p.unidades}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
